import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import { FaBars } from 'react-icons/fa';
import { AiOutlineClose } from 'react-icons/ai';
import { useAuth } from '../Auth/AuthContext';

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const sidebarRef = useRef<HTMLDivElement>(null);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeItem, setActiveItem] = useState<string | null>(null);

  const { role } = useAuth();

  const toggleSidebar = () => {
    setSidebarOpen(prevState => !prevState);
  };

  const handleOutsideClick = (event: MouseEvent) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target as Node)) {
      setSidebarOpen(false);
    }
  };

  const handleItemClick = (item: string, path: string) => {
    navigate(path);
    setActiveItem(item);
    setSidebarOpen(false);
  };

  useEffect(() => {
    if (sidebarOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [sidebarOpen]);

  useEffect(() => {
    const currentPath = location.pathname;

    if (currentPath.includes('/manage-campaigns') || currentPath.includes('/addcampaigns')) {
      setActiveItem('manageCampaigns');
    } else if (currentPath.includes('/supervisor-dashboard')) {
      setActiveItem('supervisorDashboard');
    } else {
      setActiveItem(null);
    }
  }, [location]);

  return (
    <div className="Sidebar">
      <Navbar bg="dark" data-bs-theme="dark" className="bg-body-tertiary p-3">
        <Navbar.Brand className='ms-5 custom-navbrand'>Nightlife Marketing Manager</Navbar.Brand>
        <div className="navbar-toggle" onClick={toggleSidebar}>
          {!sidebarOpen ? <FaBars className='mb-1 text-light' /> : <AiOutlineClose className='mb-1 text-light' />}
        </div>
      </Navbar>

      <div ref={sidebarRef} className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header"></div>
        <h5 className='sidebar-menu mt-2'>
          Campaigns
        </h5>
        <ul>
          <li
            className={activeItem === 'manageCampaigns' ? 'active' : ''}
            onClick={() => {
              const targetPath = role === 'Admin' ? '/admin-dashboard' : role === 'Supervisor' ? '/supervisor-dashboard' : '/manage-campaigns';
              handleItemClick('manageCampaigns', targetPath);
            }}
          >
            Manage Campaigns
          </li>

          {role === 'Supervisor' && (
            <li
              className={activeItem === 'supervisorDashboard' ? 'active' : ''}
              onClick={() => handleItemClick('supervisorDashboard', '/supervisor-dashboard')}
            >
              Supervisor Dashboard
            </li>
          )}

        </ul>
      </div>

      <div className="content">
        <Outlet />
      </div>
    </div>
  );
}

export default Sidebar;